module.exports = __webpack_public_path__ + "img/20200114160600504.16ad04ee.jpg";